import React, { useState, useEffect } from 'react';
import { Alert, Button, ListGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { setResponsible, getAllEmployees } from "../../services/EmployeesService";

function ResponsibleForm() {

    const [userEmail, setUserEmail] = useState("");
    const [responsibleEmail, setResponsibleEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [suggestions, setSuggetions] = useState([]);
    const [usersList, setUsersList] = useState([]);

    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => {
        setShowSuccess(false);
        window.location.reload();
    }
    const handleShowSuccess = () => {
        setShowError(false);
        setShowSuccess(true);
    };

    const [showError, setShowError] = useState(false);
    const handleCloseError = () => setShowError(false);
    const handleShowError = () => {
        setShowSuccess(false);
        setShowError(true);
    }

    const handleChangeEmail = (e) => {
        setUserEmail(e.target.value);
        setIsValidEmail(e.target.value.endsWith('@qualt.io'));
        const newSuggestions = usersList.filter((valor) =>
            valor.toLowerCase().startsWith(e.target.value.toLowerCase())
        );
        setSuggetions(newSuggestions);
    };

    const selectSuggestion = (suggestions) => {
        setUserEmail(suggestions);
        setIsValidEmail(true);
        setSuggetions([]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let formData = {
            user_email: userEmail,
            responsible_email: responsibleEmail
        }
        if (isValidEmail) {
            setResponsible(JSON.stringify(formData)).then(function(response) {
                if(response === undefined){
                    handleShowError();
                } else {
                    if(response.status === 200) {
                        handleShowSuccess();
                    } else {
                        handleShowError();
                    }
                } 
            });
        }
    }

    const getUserList = async () => {
        let res = await getAllEmployees();
        let emails = [];
        for (const key in res) {
            emails.push(res[key].email);
        }
        return emails;
    }

    useEffect(() => {
        getUserList().then((data) => {
            setUsersList(data);
        })
    }, [])

    return (
        <div className="container home">
            <Alert variant="success" show={showSuccess} onClose={handleCloseSuccess} dismissible>
                <p>
                Responsable asignado correctamente.
                </p>
            </Alert>
            <Alert variant="danger" show={showError} onClose={handleCloseError} dismissible>
                <p>
                Se ha producido un error.
                </p>
            </Alert>
            <h1 className="font-weight-light">Asignar responsables</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicId">
                <Form.Label>Email del usuario</Form.Label>
                <Form.Control 
                    required
                    placeholder="Email" 
                    value={userEmail}
                    onChange={handleChangeEmail}
                    isInvalid={!isValidEmail}
                />
                <ListGroup as="ul">
                    {suggestions.map((suggestion, index) => (
                        <ListGroup.Item action as="li" key={index} onClick={() => selectSuggestion(suggestion)}>
                        {suggestion}
                        </ListGroup.Item>
                    ))}
                </ListGroup>

                <Form.Control.Feedback type="invalid">
                    Por favor indica un email de usuario válido.
                </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicDays">
                <Form.Label>Responsable</Form.Label>
                <Form.Control as="select" value={responsibleEmail} onChange={e => setResponsibleEmail(e.target.value)}>
                    <option>Elige un responsable</option>
                    <option value="cesar@qualt.io">César</option>
                </Form.Control>
                </Form.Group>

                <Button variant="primary" type="submit">
                Enviar
                </Button>
            </Form>
        </div>
    );
}

export default ResponsibleForm;
